import KibanaFilterModel from './osd-filter-model';
export default class IsOneOfFilterModel extends KibanaFilterModel {
    query;
    constructor(metadata) {
        super(metadata);
        if (!metadata.key)
            return;
        const should = metadata.params.map(value => ({
            match_phrase: {
                [metadata.key]: value,
            },
        }));
        this.query = {
            bool: {
                should,
                minimum_should_match: 1,
            },
        };
    }
}
//# sourceMappingURL=is-one-of-filter-model.js.map